import { TICKER_ROUTE_NAMES, TICKER_PREVIEW_KIND } from "@/apps/ticker/ticker.routes";
import { goToField } from "@/shared/utils";

export function useTickerGoTo() {
    return {
        goToEventField(fieldId, eventCode) {
            goToField(
                TICKER_ROUTE_NAMES.projectEvents,
                TICKER_PREVIEW_KIND.ticker,
                fieldId,
                "edit-event",
                eventCode
            );
        },
    };
}
